import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { EnrollmentStep2, type EnrollmentReserveResponse } from '@fittrack/ui';
import { useMember } from '../context/MemberContext';
import { config } from '../config';
import '../pages/EnrollPage.css';

export default function EnrollJoinStep2Page() {
  const { member } = useMember();
  const navigate = useNavigate();
  const { packageId } = useParams<{ packageId: string }>();
  const [searchParams] = useSearchParams();
  const enrollmentKey = searchParams.get('key') || '';

  if (!member?.siteId) {
    return (
      <div className="enroll-page">
        <p className="enroll-empty">No site information available.</p>
      </div>
    );
  }

  return (
    <div className="enroll-page">
      <EnrollmentStep2
        companyId={config.onlineName}
        siteId={member.siteId}
        packageId={Number(packageId) || 0}
        enrollmentKey={enrollmentKey}
        apiUrl={config.apiUrl}
        authToken={sessionStorage.getItem('apiKey') ?? undefined}
        recaptchaSiteKey={config.recaptchaSiteKey}
        onSuccess={(response: EnrollmentReserveResponse) => {
          sessionStorage.setItem('pwaEnrollmentConfirmation', JSON.stringify(response));
          navigate('/enroll/confirmation');
        }}
        onCancel={() => navigate('/enroll')}
      />
    </div>
  );
}
